export const actionTypes = {
    UPDATE_HIGHLIGHTED_SEARCH_POSITION: 'SEARCH/UPDATE_HIGHLIGHTED_SEARCH_POSITION',
    UPDATE_ACTIVE_SEARCH_POSITION: 'SEARCH/UPDATE_ACTIVE_SEARCH_POSITON',
    CLEAR_ACTIVE_SEARCH: 'SEARCH/CLEAR_ACTIVE_SEARCH',
    CLEAR_HIGHLIGHTED_SEARCH: 'SEARCH/CLEAR_HIGHLIGHTED_SEARCH',
};
